<template>
    <div>
        <el-form-item label="Treść lewej kolumny"
                      :error="errors[addLanguageSuffix('title')]">
            <el-input v-model="form[addLanguageSuffix('title')]"/>
        </el-form-item>
        <el-form-item label="Treść środkowej kolumny"
                      :error="errors[addLanguageSuffix('content')]">
            <wyswig-input v-model="form[addLanguageSuffix('content')]"/>
        </el-form-item>
        <edition-input v-model="form.edition"
                       :errors="errors.edition"
                       :clearable="true"
                       :required="true"/>
        <el-form-item label="Rodzaj wydarzenia"
                      required
                      :error="errors['event_type']">
            <el-select filterable v-model="form.event_type" placeholder="Wybierz typ wydarzenia">
                <el-option v-for="type in types"
                           :key="type"
                           :label="translateType(type)"
                           :value="type"/>
            </el-select>
        </el-form-item>
    </div>
</template>
<script>
    import {OtherEvent} from '@/api'
    import EditionInput from '@/components/EditionInput'

    export default {
        props: ['form', 'errors'],
        data () {
            return {
                types: ["cinema", "theater"]
            }
        },
        methods: {
            translateType (type) {
                const translations = {
                    "music": "koncerty",
                    "cinema": "kino",
                    "theater": "teatr"
                }
                return translations[type] || type
            },
            fetchData () {
                OtherEvent.eventTypes().then(response => {
                    this.types = ["cinema", "theater", ...response.data]
                })
            }
        },
        mounted () {
            this.fetchData()
        },
        components: {
            EditionInput
        }
    }
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// RepertoireWidget.vue?9cb0ba88